<template lang="html">
    <v-card>
      <confirm-insurance-modal v-model="openConfirmDialog" :company-id="confirmInsuranceCompanyId">
      </confirm-insurance-modal>
      <v-card-title>
        <v-layout row wrap align-end>
          <v-flex xs6></v-flex>
          <v-flex xs6>
            <v-text-field v-model="search" append-icon="search"
                          label="Search companies" single-line hide-details>
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-data-table :headers="headers"
                    :custom-filter="filterCompanies"
                    :search="search"
                    :rows-per-page-items="[10,20,30]"
                    :items="companies">
          <template slot="items" slot-scope="slotItems">
            <tr  class="cursor-pointer"
                 @click="slotItems.expanded = !slotItems.expanded">
              <td class="company-id-col">
                <v-icon class="expand-icon" v-show="!slotItems.expanded">expand_more</v-icon>
                <v-icon class="expand-icon" v-show="slotItems.expanded">expand_less</v-icon>
                <v-btn block color="accent" @click="viewCompanyDetail(slotItems.item)">
                  <v-icon size="18" color="white">visibility</v-icon>
                  <span class="pl-2">Profile</span>
                </v-btn>
              </td>
              <td>
                <v-icon v-if="isVerified(slotItems.item)" color="green">verified_user</v-icon>
                <span>{{slotItems.item.companyName}}</span>
              </td>
              <td>
                <span>{{slotItems.item.contactName}}</span>
              </td>
              <td>
                <span>{{slotItems.item.contactPhone}}</span>
              </td>
              <td>
                <span>{{slotItems.item.created | formatDate}}</span>
              </td>
            </tr>
          </template>
          <template slot="expand" slot-scope="slotItems">
            <v-layout rows ml-3>
              <v-layout column>
                <v-flex>
                  <v-btn class="caption mx-0 my-0 d-block" flat color="primary"
                         @click="viewCompanyLoads(slotItems.item)">
                    <v-icon size="20">list</v-icon>
                    Loads
                  </v-btn>
                </v-flex>

                <v-flex>
                  <v-btn class="caption mx-0 my-0 d-block" flat color="primary"
                         @click="viewCompanyBids(slotItems.item)">
                    <v-icon size="20">attach_money</v-icon>
                    Bids
                  </v-btn>
                </v-flex>

                <v-flex>
                  <v-btn class="caption mx-0 my-0 d-block" flat color="primary"
                         @click="viewCompanyTransactions(slotItems.item)">
                    <v-icon size="20">payment</v-icon>
                    Transactions
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout column>
                <company-profile-card :company-profile="slotItems.item">
                </company-profile-card>
              </v-layout>
            </v-layout>
            <v-layout row class="px-3 py-3">
              <v-flex>
                <v-btn @click="showConfirmDialog(slotItems.item.id)"
                       v-if="isLtnAdmin"
                       class="accent ml-0 mr-3 my-0">
                  Confirm Insurance Certificate
                </v-btn>
              </v-flex>
            </v-layout>
          </template>
        </v-data-table>
    </v-card>
</template>

<script>
import _ from 'lodash';
import CompanyProfileCard from '@/components/CompanyProfileCard';

import { mapGetters } from 'vuex';
import ConfirmInsuranceModal from '../../components/modals/ConfirmInsuranceModal';

export default {
  name: 'CompanyTable',
  props: {
    companies: {
      type: Array,
    },
  },
  data: () => ({
    tab: 1,
    search: null,
    confirmInsuranceCompanyId: null,
    openConfirmDialog: false,
  }),
  components: {
    ConfirmInsuranceModal,
    CompanyProfileCard,
  },
  computed: {
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    headers() {
      return [
        { text: 'View', value: 'company-id', width: '30px', class: 'company-id-header', sortable: false },
        { text: 'Name', value: 'companyName' },
        { text: 'Contact Name', value: 'contactName', width: '200px' },
        { text: 'Phone', value: 'contactPhone' },
        { text: 'Created', value: 'created' },
      ];
    },
  },
  methods: {
    showConfirmDialog(companyId){
      this.confirmInsuranceCompanyId = companyId;
      this.openConfirmDialog = true;
    },
    loadCompanies() {
      this.$store.dispatch('applications/addLoading', [
        this.$store.dispatch('companies/getCompanies'),
      ]);
    },
    isVerified(company) {
      return !_.isEmpty(this.companyVerifiedDate(company));
    },
    companyStatus(company) {
      return _.get(company, 'accountStatus');
    },
    companyVerifiedDate(company) {
      return _.get(this.companyStatus(company), 'verified');
    },
    accountSubmission(company) {
      return _.get(company, 'accountRequest');
    },
    accountSubmissionCompanyFocus(company) {
      return _.get(this.accountSubmission(company), 'companyType');
    },
    accountSubmissionPosition(company) {
      return _.get(this.accountSubmission(company), 'companyPosition');
    },
    accountSubmissionContactName(company) {
      return _.get(this.accountSubmission(company), 'name');
    },
    accountSubmissionCompanyName(company) {
      return _.get(this.accountSubmission(company), 'companyName');
    },
    accountSubmissionPhone(company) {
      return _.get(this.accountSubmission(company), 'phone');
    },
    accountSubmissionNotes(company) {
      return _.get(this.accountSubmission(company), 'notes');
    },
    accountSubmissionContactEmail(company) {
      return _.get(this.accountSubmission(company), 'email');
    },
    viewCompanyDetail(company) {
      const companyId = _.get(company, 'id');
      this.$router.push({ name: 'company.settings', params: { id: companyId } });
    },
    viewCompanyLoads(company) {
      const companyId = _.get(company, 'id');
      this.$router.push({ name: 'company.loads.section', params: { id: companyId } });
    },
    viewCompanyBids(company) {
      const companyId = _.get(company, 'id');
      this.$router.push({ name: 'company.placed-bids', params: { id: companyId } });
    },
    viewCompanyTransactions(company) {
      const companyId = _.get(company, 'id');
      this.$router.push({ name: 'company.transactions', params: { id: companyId } });
    },
    filterCompanies(items, searchString, filter) {
      const search = searchString.toString().toLowerCase();
      return items.filter(company =>
        filter(company.companyName, search) ||
        filter(company.contactName, search) ||
        filter(company.contactPhone, search));
    },
  },
};
</script>

<style>
  .company-id-header {
    padding-left: 35px !important;
  }

  .company-id-col {
    position: relative;
    padding-left: 35px !important;
  }

  .company-id-col .expand-icon {
    position: absolute;
    left: 5px;
    top: auto;
    bottom: auto;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Companies/CompanyTable.vue